export default __webpack_public_path__ + "static/media/malik.cfc2685d.png";